import { useContext } from 'react'
import { useSelector } from 'react-redux'
import PageContext from '@contexts/pageContext'

export const isNotificationFlag = flag => /^Disable_.*_Notification$/.test(flag)

const editFlags = (flags, showEditFlagsModal, type) => new Promise((resolve, reject) => {
  if (showEditFlagsModal){
    const payload = {
      flags: flags[type] || [],
      type,
    }

    if (type === 'user'){
      payload.flags = payload.flags.filter(x => !isNotificationFlag(x.value))
    }

    showEditFlagsModal(payload)

    return resolve({ success: true, result: payload })
  }

  return reject(new Error('showEditFlagsModal not defined in PageContext callbacks'))
})

const useFlags = () => {
  const { callbacks } = useContext(PageContext)
  const { showEditFlagsModal } = callbacks || {}

  const { result: userFlagsV4 } = useSelector(reduxState => reduxState.userFlagsV4)
  const { result: providerFlagsV4 } = useSelector(reduxState => reduxState.providerFlagsV4)
  const { result: zoneFlagsV4 } = useSelector(reduxState => reduxState.zoneFlagsV4)
  const { result: clientFlagsV4 } = useSelector(reduxState => reduxState.clientFlagsV4)

  const flags = {
    provider: providerFlagsV4,
    user: userFlagsV4,
    zone: zoneFlagsV4,
    client: clientFlagsV4,
    notification: userFlagsV4?.filter(x => isNotificationFlag(x.value)) || [],
  }

  return {
    callbacks: {
      editFlags: type => editFlags(flags, showEditFlagsModal, type),
    },
  }
}

export default useFlags
